import { Routes, Route } from "react-router-dom";

import Categories from "../Pages/Categories";
import CategoryOption from "../Pages/CategoryOption";
import Cms from "../Pages/Cms";
import Enqueries from "../Pages/Enqueries";
import SuccessStories from "../Pages/SuccessStories";

const PageRoutes = () => {
  return (
    <Routes>

      <Route path="/" element={<Categories />} />
      <Route path="/category-options/:categoryId" element={<CategoryOption />} />
      <Route path="/cms-content/:categoryId" element={<Cms />} />
      <Route path="/cms-content/:categoryId/:optionId" element={<Cms />} />
      <Route path="/enquiries" element={<Enqueries />} />
      <Route path="/success-stories" element={<SuccessStories />} />

    </Routes>
  );
};

export default PageRoutes;